import React from "react";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

const NoDataView = ({
    entity,
    className,
    path = null,
    clickCallback = null,
    includeText = true,
}) => {
    return (
        <>
            <div
                className={`no-result-wrapper flex items-center justify-center ${className}`}
            >
                <div className="no-result-item text-center">
                    <div className="no-result-img">
                        <img
                            src={
                                require("../../assets/images/no-data.png")
                                    .default
                            }
                            alt="NoResultImage"
                        />
                    </div>
                    {includeText && (
                        <>
                            <h3 className="no-result-title">
                                <Trans i18nKey="noDataViewHeader">
                                    Welcome to the {{ entity }} page
                                </Trans>
                            </h3>
                            <p className="no-result-message">
                                <Trans i18nKey="unableToFindRecords">
                                    Get started by creating a{" "}
                                    {{ entity: entity.slice(0, -1) }}! All your
                                    {{ entities: entity }} will be displayed on
                                    this page
                                </Trans>
                                {path !== null && (
                                    <Link to={path}>
                                        <Trans i18nKey="createOneNow">
                                            , Create one now!
                                        </Trans>
                                    </Link>
                                )}
                                {clickCallback !== null && (
                                    <span onClick={clickCallback}>
                                        <Trans i18nKey="createOneNow">
                                            , Create one now!
                                        </Trans>
                                    </span>
                                )}
                            </p>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default NoDataView;
